
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x/api/charts/chart-image-export-options",
      function () {
        return require("private-next-pages/x/api/charts/chart-image-export-options.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x/api/charts/chart-image-export-options"])
      });
    }
  